export const DATE_PICKER_DATE_FORMAT = 'DD/MM/YYYY';
export const DATE_FORMAT = 'dd/MM/yyyy';
export const DATE_FORMAT_WITH_DOTS_AS_SEPARATORS = 'dd.MM.yyyy';
export const DATE_FORMAT_WITH_DASHES = 'yyyy-MM-dd';
export const DATE_TIME_ISO_FORMAT = "yyyy-MM-dd'T'HH:mm:ss";
export const DATE_FORMAT_WITH_SHORT_MONTH_SHORT_DAY_SHORT_YEAR = 'M/d/yy';
export const DATE_FORMAT_WITH_DASHES_REVERSED = 'dd-MM-yyyy';
